<div class="clamp-{{background}}-{{lines}} min-{{minLines}} {{type}} {{fixedHeight ? 'fixedHeight' : ''}}">
    <div class="content">
        <ng-content></ng-content>
    </div>
</div>
